import * as i0 from '@angular/core';
import * as i1 from './search.module';
import * as i2 from '@angular/common';
import * as i3 from '@angular/forms';
import * as i4 from '@angular/router';
import * as i5 from '@angular/cdk/bidi';
import * as i6 from '@angular/cdk/scrolling';
import * as i7 from '@angular/cdk/overlay';
import * as i8 from '@angular/cdk/portal';
import * as i9 from '../cdk/overlay/mapping';
import * as i10 from '../cdk/overlay/overlay-container';
import * as i11 from '../icon/icon.component';
import * as i12 from '../button/button.component';
import * as i13 from './search.component';
import * as i14 from '../shared/shared.module';
import * as i15 from '../cdk/overlay/overlay.module';
import * as i16 from '../icon/icon.module';
import * as i17 from '../button/button.module';
export const ElSearchModuleNgFactory:i0.NgModuleFactory<i1.ElSearchModule> = (null as any);
var _decl0_0:i2.NgClass = (<any>(null as any));
var _decl0_1:i2.NgComponentOutlet = (<any>(null as any));
var _decl0_2:i2.NgForOf<any> = (<any>(null as any));
var _decl0_3:i2.NgIf = (<any>(null as any));
var _decl0_4:i2.NgTemplateOutlet = (<any>(null as any));
var _decl0_5:i2.NgStyle = (<any>(null as any));
var _decl0_6:i2.NgSwitch = (<any>(null as any));
var _decl0_7:i2.NgSwitchCase = (<any>(null as any));
var _decl0_8:i2.NgSwitchDefault = (<any>(null as any));
var _decl0_9:i2.NgPlural = (<any>(null as any));
var _decl0_10:i2.NgPluralCase = (<any>(null as any));
var _decl0_11:i3.ɵangular_packages_forms_forms_z = (<any>(null as any));
var _decl0_12:i3.NgSelectOption = (<any>(null as any));
var _decl0_13:i3.ɵangular_packages_forms_forms_y = (<any>(null as any));
var _decl0_14:i3.DefaultValueAccessor = (<any>(null as any));
var _decl0_15:i3.NumberValueAccessor = (<any>(null as any));
var _decl0_16:i3.RangeValueAccessor = (<any>(null as any));
var _decl0_17:i3.CheckboxControlValueAccessor = (<any>(null as any));
var _decl0_18:i3.SelectControlValueAccessor = (<any>(null as any));
var _decl0_19:i3.SelectMultipleControlValueAccessor = (<any>(null as any));
var _decl0_20:i3.RadioControlValueAccessor = (<any>(null as any));
var _decl0_21:i3.NgControlStatus = (<any>(null as any));
var _decl0_22:i3.NgControlStatusGroup = (<any>(null as any));
var _decl0_23:i3.RequiredValidator = (<any>(null as any));
var _decl0_24:i3.MinLengthValidator = (<any>(null as any));
var _decl0_25:i3.MaxLengthValidator = (<any>(null as any));
var _decl0_26:i3.PatternValidator = (<any>(null as any));
var _decl0_27:i3.CheckboxRequiredValidator = (<any>(null as any));
var _decl0_28:i3.EmailValidator = (<any>(null as any));
var _decl0_29:i3.NgModel = (<any>(null as any));
var _decl0_30:i3.NgModelGroup = (<any>(null as any));
var _decl0_31:i3.NgForm = (<any>(null as any));
var _decl0_32:i3.NgFormSelectorWarning = (<any>(null as any));
var _decl0_33:i4.RouterOutlet = (<any>(null as any));
var _decl0_34:i4.RouterLink = (<any>(null as any));
var _decl0_35:i4.RouterLinkWithHref = (<any>(null as any));
var _decl0_36:i4.RouterLinkActive = (<any>(null as any));
var _decl0_37:i4.ɵangular_packages_router_router_l = (<any>(null as any));
var _decl0_38:i5.Dir = (<any>(null as any));
var _decl0_39:i6.CdkFixedSizeVirtualScroll = (<any>(null as any));
var _decl0_40:i6.CdkScrollable = (<any>(null as any));
var _decl0_41:i6.CdkVirtualForOf<any> = (<any>(null as any));
var _decl0_42:i6.CdkVirtualScrollViewport = (<any>(null as any));
var _decl0_43:i7.CdkConnectedOverlay = (<any>(null as any));
var _decl0_44:i7.CdkOverlayOrigin = (<any>(null as any));
var _decl0_45:i8.CdkPortal = (<any>(null as any));
var _decl0_46:i8.CdkPortalOutlet = (<any>(null as any));
var _decl0_47:i9.ElPortalDirective = (<any>(null as any));
var _decl0_48:i9.ElPortalOutletDirective = (<any>(null as any));
var _decl0_49:i10.ElOverlayContainerComponent = (<any>(null as any));
var _decl0_50:i11.ElIconComponent = (<any>(null as any));
var _decl0_51:i12.ElButtonComponent = (<any>(null as any));
var _decl0_52:i13.ElSearchComponent = (<any>(null as any));
var _decl0_53:i13.ElSearchFieldComponent = (<any>(null as any));
var _decl0_54:i2.AsyncPipe = (<any>(null as any));
var _decl0_55:i2.UpperCasePipe = (<any>(null as any));
var _decl0_56:i2.LowerCasePipe = (<any>(null as any));
var _decl0_57:i2.JsonPipe = (<any>(null as any));
var _decl0_58:i2.SlicePipe = (<any>(null as any));
var _decl0_59:i2.DecimalPipe = (<any>(null as any));
var _decl0_60:i2.PercentPipe = (<any>(null as any));
var _decl0_61:i2.TitleCasePipe = (<any>(null as any));
var _decl0_62:i2.CurrencyPipe = (<any>(null as any));
var _decl0_63:i2.DatePipe = (<any>(null as any));
var _decl0_64:i2.I18nPluralPipe = (<any>(null as any));
var _decl0_65:i2.I18nSelectPipe = (<any>(null as any));
var _decl0_66:i2.KeyValuePipe = (<any>(null as any));
var _decl0_67:i14.ElSharedModule = (<any>(null as any));
var _decl0_68:i15.ElOverlayModule = (<any>(null as any));
var _decl0_69:i16.ElIconModule = (<any>(null as any));
var _decl0_70:i17.ElButtonModule = (<any>(null as any));
var _decl0_71:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_72:i0.ElementRef<any> = (<any>(null as any));
function _View_ElSearchComponent_Host_1_0():void {
  var _any:any = (null as any);
}
function _View_ElSearchComponent_1_1():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_52.type;
  currVal_0;
  const currVal_1:any = _decl0_52.placeholder;
  currVal_1;
  const currVal_2:any = _decl0_52.hint;
  currVal_2;
  const currVal_3:any = _decl0_52.showSearchField;
  currVal_3;
  const currVal_4:any = _decl0_53.showClass;
  currVal_4;
  const currVal_5:any = _decl0_53.modalZoomin;
  currVal_5;
  const currVal_6:any = _decl0_53.rotateLayout;
  currVal_6;
  const currVal_7:any = _decl0_53.modalMove;
  currVal_7;
  const currVal_8:any = _decl0_53.curtain;
  currVal_8;
  const currVal_9:any = _decl0_53.columnCurtain;
  currVal_9;
  const currVal_10:any = _decl0_53.modalDrop;
  currVal_10;
  const currVal_11:any = _decl0_53.modalHalf;
  currVal_11;
  const pd_12:any = ((<any>_decl0_52.search(_any)) !== false);
  const pd_13:any = ((<any>_decl0_52.emitInput(_any)) !== false);
  const pd_14:any = ((<any>_decl0_52.emitDeactivate()) !== false);
}
function _View_ElSearchComponent_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = '';
  currVal_0;
  const currVal_1:any = _decl0_51.filled;
  currVal_1;
  const currVal_2:any = _decl0_51.outline;
  currVal_2;
  const currVal_3:any = _decl0_51.ghost;
  currVal_3;
  const currVal_4:any = _decl0_51.hero;
  currVal_4;
  const currVal_5:any = _decl0_51.fullWidth;
  currVal_5;
  const currVal_6:any = _decl0_51.disabled;
  currVal_6;
  const currVal_7:any = _decl0_51.disabled;
  currVal_7;
  const currVal_8:any = _decl0_51.tabbable;
  currVal_8;
  const currVal_9:any = _decl0_51.tiny;
  currVal_9;
  const currVal_10:any = _decl0_51.small;
  currVal_10;
  const currVal_11:any = _decl0_51.medium;
  currVal_11;
  const currVal_12:any = _decl0_51.large;
  currVal_12;
  const currVal_13:any = _decl0_51.giant;
  currVal_13;
  const currVal_14:any = _decl0_51.primary;
  currVal_14;
  const currVal_15:any = _decl0_51.info;
  currVal_15;
  const currVal_16:any = _decl0_51.success;
  currVal_16;
  const currVal_17:any = _decl0_51.warning;
  currVal_17;
  const currVal_18:any = _decl0_51.danger;
  currVal_18;
  const currVal_19:any = _decl0_51.rectangle;
  currVal_19;
  const currVal_20:any = _decl0_51.round;
  currVal_20;
  const currVal_21:any = _decl0_51.semiRound;
  currVal_21;
  const currVal_22:any = _decl0_51.iconLeft;
  currVal_22;
  const currVal_23:any = _decl0_51.iconRight;
  currVal_23;
  const currVal_24:any = _decl0_51.transitions;
  currVal_24;
  const currVal_25:any = 'search-outline';
  currVal_25;
  const currVal_26:any = 'endlessjs-essentials';
  currVal_26;
  const currVal_27:any = _decl0_50.html;
  currVal_27;
  const currVal_28:any = _decl0_50.primary;
  currVal_28;
  const currVal_29:any = _decl0_50.info;
  currVal_29;
  const currVal_30:any = _decl0_50.success;
  currVal_30;
  const currVal_31:any = _decl0_50.warning;
  currVal_31;
  const currVal_32:any = _decl0_50.danger;
  currVal_32;
  const pd_33:any = ((<any>_decl0_51.onClick(_any)) !== false);
  const pd_34:any = ((<any>_decl0_52.emitActivate()) !== false);
}
function _View_ElSearchFieldComponent_Host_2_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_53.showClass;
  currVal_0;
  const currVal_1:any = _decl0_53.modalZoomin;
  currVal_1;
  const currVal_2:any = _decl0_53.rotateLayout;
  currVal_2;
  const currVal_3:any = _decl0_53.modalMove;
  currVal_3;
  const currVal_4:any = _decl0_53.curtain;
  currVal_4;
  const currVal_5:any = _decl0_53.columnCurtain;
  currVal_5;
  const currVal_6:any = _decl0_53.modalDrop;
  currVal_6;
  const currVal_7:any = _decl0_53.modalHalf;
  currVal_7;
}
function _View_ElSearchFieldComponent_2_0():void {
  var _any:any = (null as any);
  const currVal_0:any = '';
  currVal_0;
  const currVal_1:any = _decl0_51.filled;
  currVal_1;
  const currVal_2:any = _decl0_51.outline;
  currVal_2;
  const currVal_3:any = _decl0_51.ghost;
  currVal_3;
  const currVal_4:any = _decl0_51.hero;
  currVal_4;
  const currVal_5:any = _decl0_51.fullWidth;
  currVal_5;
  const currVal_6:any = _decl0_51.disabled;
  currVal_6;
  const currVal_7:any = _decl0_51.disabled;
  currVal_7;
  const currVal_8:any = _decl0_51.tabbable;
  currVal_8;
  const currVal_9:any = _decl0_51.tiny;
  currVal_9;
  const currVal_10:any = _decl0_51.small;
  currVal_10;
  const currVal_11:any = _decl0_51.medium;
  currVal_11;
  const currVal_12:any = _decl0_51.large;
  currVal_12;
  const currVal_13:any = _decl0_51.giant;
  currVal_13;
  const currVal_14:any = _decl0_51.primary;
  currVal_14;
  const currVal_15:any = _decl0_51.info;
  currVal_15;
  const currVal_16:any = _decl0_51.success;
  currVal_16;
  const currVal_17:any = _decl0_51.warning;
  currVal_17;
  const currVal_18:any = _decl0_51.danger;
  currVal_18;
  const currVal_19:any = _decl0_51.rectangle;
  currVal_19;
  const currVal_20:any = _decl0_51.round;
  currVal_20;
  const currVal_21:any = _decl0_51.semiRound;
  currVal_21;
  const currVal_22:any = _decl0_51.iconLeft;
  currVal_22;
  const currVal_23:any = _decl0_51.iconRight;
  currVal_23;
  const currVal_24:any = _decl0_51.transitions;
  currVal_24;
  const currVal_25:any = 'close-outline';
  currVal_25;
  const currVal_26:any = 'endlessjs-essentials';
  currVal_26;
  const currVal_27:any = _decl0_50.html;
  currVal_27;
  const currVal_28:any = _decl0_50.primary;
  currVal_28;
  const currVal_29:any = _decl0_50.info;
  currVal_29;
  const currVal_30:any = _decl0_50.success;
  currVal_30;
  const currVal_31:any = _decl0_50.warning;
  currVal_31;
  const currVal_32:any = _decl0_50.danger;
  currVal_32;
  const currVal_33:any = _decl0_22.ngClassUntouched;
  currVal_33;
  const currVal_34:any = _decl0_22.ngClassTouched;
  currVal_34;
  const currVal_35:any = _decl0_22.ngClassPristine;
  currVal_35;
  const currVal_36:any = _decl0_22.ngClassDirty;
  currVal_36;
  const currVal_37:any = _decl0_22.ngClassValid;
  currVal_37;
  const currVal_38:any = _decl0_22.ngClassInvalid;
  currVal_38;
  const currVal_39:any = _decl0_22.ngClassPending;
  currVal_39;
  const currVal_40:any = _decl0_53.placeholder;
  currVal_40;
  const currVal_41:any = _decl0_53.hint;
  currVal_41;
  const pd_42:any = ((<any>_decl0_53.emitClose()) !== false);
  const pd_43:any = ((<any>_decl0_51.onClick(_any)) !== false);
  const pd_44:any = ((<any>_decl0_53.emitClose()) !== false);
  const pd_45:any = ((<any>_decl0_31.onSubmit(_any)) !== false);
  const pd_46:any = ((<any>_decl0_31.onReset()) !== false);
  const pd_47:any = ((<any>_decl0_53.submitSearch(_any.value)) !== false);
  const pd_48:any = ((<any>_decl0_53.emitSearchInput(_any.value)) !== false);
  const pd_49:any = ((<any>_decl0_53.focusInput()) !== false);
}
